import { CHART_CATALOG } from '../catalog/chartCatalog';

type IssueChartCatalogEntry = Extract<
  (typeof CHART_CATALOG)[number],
  { section: 'issues'; enabled: true }
>;

export type CatalogIssueChartId = IssueChartCatalogEntry['id'];

export const CATALOG_ISSUE_CHART_IDS = CHART_CATALOG.filter(
  (entry) => entry.section === 'issues' && entry.enabled
).map((entry) => entry.id) as readonly CatalogIssueChartId[];

export function isCatalogIssueChartId(id: string): id is CatalogIssueChartId {
  return (CATALOG_ISSUE_CHART_IDS as readonly string[]).includes(id);
}
